<template>
  <!-- <div> -->
  <Dropdown
    :style="{width: '100%', position: 'relative'}"
    :visible="visible"
    class="customDrop"
    ref="dropRef"
    trigger="custom"
  >
    <Input
      :icon="visible?'ios-arrow-up':'ios-arrow-down'"
      @on-clear="clear"
      @on-click="handleOpen"
      @on-focus="handleOpen"
      clearable
      placeholder="请选择组织机构"
      readonly
      v-model="orgName"
    ></Input>
    <DropdownMenu slot="list">
      <div class="treePanel">
        <AgilityOrgTree
          :opts="{...orgOpts, size: 'small'}"
          @changeSelectNode="changeOrg"
          ref="tree"
        />
      </div>
    </DropdownMenu>
  </Dropdown>
  <!-- </div> -->
</template>
<script>
export default {
  name: 'orgSelect',
  props: {
    value: '',
    orgOpts: {}
  },
  data () {
    return {
      visible: false,
      iconValue: '',
      currentNode: null,
      orgId: null,
      orgName: ''
    }
  },
  watch: {
    value: {
      handler (newValue, oldValue) {
        this.orgId = newValue
      }
    }
  },
  methods: {
    close: function () {
      this.visible = false
    },
    handleOpen: function () {
      this.visible = !this.visible
    },
    clear: function () {
      this.close()
      this.orgId = null
      this.orgName = ''
      this.$emit('change', {})
    },
    changeOrg: function (data) {
      console.log('changeOrg', data)
      if (data.checked) {
        this.currentNode = data.node
        this.orgId = data.node.id
        this.orgName = data.node.name
      } else {
        this.currentNode = null
        this.orgId = 0
      }
      this.$emit('change', data)
      this.close()
    },
    outClick (e) {
      let dropRef = this.$refs.dropRef.$el
      if (!dropRef.contains(e.target) && this.visible) {
        this.visible = false
      }
    }
  },
  beforeMount () {
    this.close()
    document.getElementById("app").addEventListener('click', this.outClick)
  },
  beforeDestroy () {
    this.close()
    document.getElementById("app").removeEventListener('click', this.outClick)
  }
}
</script>

<style scoped>
/* .treePanel > div {
  padding: 0 1rem;
  cursor: pointer;
} */
.treePanel {
  padding: 0 1rem;
  max-width: 240px;
}
</style>